import React from 'react'
import PropTypes from 'prop-types'
import { Configure } from 'react-instantsearch-dom'
import { isNil } from 'ramda'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { directoryBookThisWeekFilters } from '@lib/coaches-directory/book-this-week'
import {
  COACH_DIRECTORY_ATTRIBUTES_TO_RETRIEVE,
  DIRECTORY_SEARCH_RADIUS_METERS,
  DIRECTORY_SEARCH_RADIUS_MILES,
} from '@lib/algolia/coach-directory-search-config'

export { COACH_DIRECTORY_ATTRIBUTES_TO_RETRIEVE, DIRECTORY_SEARCH_RADIUS_METERS, DIRECTORY_SEARCH_RADIUS_MILES }

const tenMilesInMeters = 10 * 1609
const facetsDefault = ['_geoloc', 'zip', 'serviceTypes.services.serviceName', 'experienceTypes.experiences.experienceName', 'gender', 'memberType']

const coachAttributes = COACH_DIRECTORY_ATTRIBUTES_TO_RETRIEVE

export function ConfigureWithLatLng({
  aroundLatLng,
  aroundRadius,
  filters = '',
}) {
  const isTablet = useMediaQuery(useTheme().breakpoints.between('sm', 'md'))
  // 3-across desktop (md+) loads 3 rows; 2-across tablet loads 4 rows.
  const hitsPerPage = isTablet ? 8 : 9
  const facets = facetsDefault
  const aroundPrecision = tenMilesInMeters
  const attributesToRetrieve = coachAttributes
  return (
    <Configure
      aroundLatLng={aroundLatLng}
      aroundRadius={aroundRadius || DIRECTORY_SEARCH_RADIUS_METERS}
      aroundPrecision={aroundPrecision}
      hitsPerPage={hitsPerPage}
      maxValuesPerFacet={50}
      facets={facets}
      filters={filters}
      sumOrFiltersScores
      attributesToRetrieve={attributesToRetrieve}
      getRankingInfo
    />
  )
}

ConfigureWithLatLng.propTypes = {
  aroundLatLng: PropTypes.string,
  aroundRadius: PropTypes.number,
  filters: PropTypes.string,
}

export function ConfigureWithoutLatLng({ aroundRadius, filters = '' }) {
  const isTablet = useMediaQuery(useTheme().breakpoints.between('sm', 'md'))
  // 3-across desktop (md+) loads 3 rows; 2-across tablet loads 4 rows.
  const hitsPerPage = isTablet ? 8 : 9
  const facets = facetsDefault
  const aroundPrecision = tenMilesInMeters
  const attributesToRetrieve = coachAttributes
  return (
    <Configure
      hitsPerPage={hitsPerPage}
      aroundLatLngViaIP
      aroundPrecision={aroundPrecision}
      aroundRadius={aroundRadius || DIRECTORY_SEARCH_RADIUS_METERS}
      maxValuesPerFacet={50}
      facets={facets}
      filters={filters}
      sumOrFiltersScores
      attributesToRetrieve={attributesToRetrieve}
      getRankingInfo // additional geo info, can be removed after search priority investigation
    />
  )
}

ConfigureWithoutLatLng.propTypes = {
  aroundRadius: PropTypes.number,
  filters: PropTypes.string,
}

function ConfigureWithLocation({
  aroundLatLng,
  aroundRadius,
  bookThisWeekOnly = false,
  objectIDs,
  ready = true,
}) {
  const filters = directoryBookThisWeekFilters({
    bookThisWeekOnly,
    objectIDs,
    ready,
  })
  return isNil(aroundLatLng)
    ? (
      <ConfigureWithoutLatLng aroundRadius={aroundRadius} filters={filters} />
    )
    : (
      <ConfigureWithLatLng {...{
        aroundLatLng,
        aroundRadius,
        filters,
      }}
      />
    )
}

ConfigureWithLocation.propTypes = {
  aroundLatLng: PropTypes.string,
  aroundRadius: PropTypes.number,
  bookThisWeekOnly: PropTypes.bool,
  objectIDs: PropTypes.arrayOf(PropTypes.string),
  ready: PropTypes.bool,
}

export default ConfigureWithLocation
